import React from "react";
import { searchService } from "../../../services/searchService";

function ServiceAreas({ programSiteId }) {
  const [areas, setAreas] = React.useState([]);

  React.useEffect(() => {
    if (!programSiteId) return;
    searchService.getServiceAreas(programSiteId).then((data) => {
      setAreas(data || []);
    }).catch(() => {});
  }, [programSiteId]);

  if (areas.length === 0) return null;

  return (
    <div className="service-areas" style={{ textTransform: 'capitalize' }}>
      {areas.map((area) => area.name || area).join(", ")}
    </div>
  );
}

export default ServiceAreas;
